import { ImageOrientation } from '@space-core/components/customImage/enum'
import { focusVisible } from '@space-core/styles'
import clsx from 'clsx'
import styled from 'styled-components'

import ProductCardDefault from '../default'
import type { ProductCardProps } from '../types'

import '@hotmart/cosmos/dist/styles/utilities/text/variations/green.css'

const ProductButton = styled.a`
  background: 0;
  ${focusVisible}

  &:hover {
    ._child-vertical {
      display: flex;
      background-color: var(--black);
      height: 100%;
      opacity: 0.8;
      border-radius: 0.5rem;
      align-items: end;
      transition: opacity 0.2s ease-out;
    }
  }
`

const ProductTitleVertical = styled.h3`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-break: auto;
`

const ProductCard = ({
  product,
  handleClick,
  items,
  orientation,
  containerOrientation,
  imageOrientation,
  stylesCustomProductCommunity
}: ProductCardProps) => {
  const productCardClass = clsx('_border-0  _w-full _p-0', {
    '_cursor-pointer': !!handleClick
  })

  return (
    <ProductButton
      data-test='product-btn'
      onClick={handleClick}
      className={productCardClass}
      tabIndex={0}>
      <ProductCardDefault
        product={product}
        items={items}
        orientation={orientation}
        containerOrientation={containerOrientation}
        imageOrientation={imageOrientation}
        stylesCustomProductCommunity={stylesCustomProductCommunity}
      />

      {imageOrientation === ImageOrientation.VERTICAL && (
        <>
          <ProductTitleVertical className='_mt-3 _mb-0 _pb-0 _font-18 _text-gray-900 _font-weight-bold _text-left'>
            {product.name}
          </ProductTitleVertical>

          {Boolean(product.price) && !product.isPurchased && (
            <p className='_mt-2 _mb-0 _text-2 _font-weight-bold _text-green'>{product.price}</p>
          )}
        </>
      )}
    </ProductButton>
  )
}

export default ProductCard
